import * as React from "react";
import type { SVGProps } from "react";
const SvgWebsite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path stroke="#26A3DD" strokeWidth={1.75} d="M2.005 19.89h60" />
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="M10.695 15.79a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM20.205 15.79a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM29.795 15.79a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    />
    <path
      fill="#D3ECF8"
      d="M40.094 25.2h15.7c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-15.7c-.7 0-1.2-.5-1.2-1.2.1-.7.6-1.2 1.2-1.2ZM40.094 29.5h15.7c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-15.7c-.7 0-1.2-.5-1.2-1.2.1-.7.6-1.2 1.2-1.2ZM40.094 33.7h5.9c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-5.9c-.7 0-1.2-.5-1.2-1.2.1-.6.6-1.2 1.2-1.2ZM40.094 43.29h15.7c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-15.7c-.7 0-1.2-.5-1.2-1.2.1-.7.6-1.2 1.2-1.2ZM40.094 47.59h15.7c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-15.7c-.7 0-1.2-.5-1.2-1.2.1-.7.6-1.2 1.2-1.2ZM10.505 43.29h19.5c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-19.5c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2ZM10.505 47.59h19.5c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-19.5c-.7 0-1.2-.5-1.2-1.2 0-.6.5-1.2 1.2-1.2Z"
    />
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="M12.105 25.29h16.1c1 0 1.9.8 1.9 1.9v8.8c0 1-.8 1.9-1.9 1.9h-16.1c-1 0-1.9-.8-1.9-1.9v-8.8c.1-1.1.9-1.9 1.9-1.9Z"
    />
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="M57.995 7h-52a4 4 0 0 0-4 4v42a4 4 0 0 0 4 4h52a4 4 0 0 0 4-4V11a4 4 0 0 0-4-4Z"
    />
  </svg>
);
export default SvgWebsite;
